import NavBar from "../NavBar/NavBar";
import ProductList from "../ProductList/ProductList";
import "./App.scss";

function App() {
  return (
    <div className="App">
      <NavBar />
      <ProductList />
    </div>
  );
}

export default App;
